export default from './icon-tooltip';



// WEBPACK FOOTER //
// ./app/components/icon-tooltip/index.js